import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "./persistStorage";

import companyReducer from "@/store/slices/companySlice";
import shareholderReducer from "@/store/slices/shareholderSlice";
import documentReducer from "@/store/slices/documentSlice";
import packageReducer from "@/store/slices/packageSlice";
import stateReducer from "@/store/slices/stateSlice";
import statePriceReducer from "@/store/slices/statePriceSlice";
import mailBoxReducer from "@/store/slices/mailBoxSlice";
import rewardReducer from "@/store/slices/rewardSlice";
import supportServiceReducer from "@/store/slices/supportServiceSlice";
import supportReducer from "@/store/slices/supportSlice";
import memberReducer from "@/store/slices/memberSlice";
import identityVerificationReducer from "@/store/slices/identityVerificationSlice";
import bdShareholderReducer from "@/store/slices/bdShareholderSlice";
import popupReducer from "@/store/slices/popupMessageSlice";
import renewalReducer from "@/store/slices/renewalSlice";
import onboardReducer from "@/store/slices/onboardSlice";
import businessTypeReducer from "@/store/slices/businessTypeSlice";
import countryReducer from "@/store/slices/countrySlice";
import entityEndingReducer from "@/store/slices/entityEndingSlice";
import sicReducer from "@/store/slices/sicSlice";
import businessActivityReducer from "@/store/slices/businessActivitySlice";
import { companyApi } from "@/store/api/companyApi";
import { shareholderApi } from "@/store/api/shareholderApi";
import { documentApi } from "@/store/api/documentApi";
import { packageApi } from "@/store/api/packageApi";
import { stateApi } from "@/store/api/stateApi";
import { statePriceApi } from "@/store/api/statePriceApi";
import {mailBoxApi} from "@/store/api/mailBoxApi";
import {rewardApi} from "@/store/api/rewardApi";
import {supportServiceApi} from "@/store/api/supportServiceApi";
import {supportApi} from "@/store/api/supportApi";
import {memberApi} from "@/store/api/memberApi";
import {bdShareholderApi} from "@/store/api/bdShareholderApi";
import {renewalApi} from "@/store/api/renewalApi";
import {businessTypeApi} from "@/store/api/businessTypeApi";
import {countryApi} from "@/store/api/countryApi";
import {entityEndingApi} from "@/store/api/entityEndingApi";
import {sicApi} from "@/store/api/sicApi";
import {businessActivityApi} from "@/store/api/businessActivityApi";


const persistConfig = {
  key: "company",
  storage,
  whitelist: ["selectedCompany"],
};

const persistedCompanyReducer = persistReducer(
  persistConfig,
  companyReducer
);

export const store = configureStore({
  reducer: {
    company: persistedCompanyReducer,
    shareholder: shareholderReducer,
    document: documentReducer,
    package: packageReducer,
    states: stateReducer,
    statePrices: statePriceReducer,
    mailBoxes: mailBoxReducer,
    rewards: rewardReducer,
    supportService: supportServiceReducer,
    support: supportReducer,
    member: memberReducer,
    identityVerification: identityVerificationReducer,
    popup: popupReducer,
    bdShareholder: bdShareholderReducer,
    renewal: renewalReducer,
    onboard: onboardReducer,
    businessTypes: businessTypeReducer,
    countries: countryReducer,
    entityEnding: entityEndingReducer,
    sics: sicReducer,
    businessActivities: businessActivityReducer,
    [memberApi.reducerPath]: memberApi.reducer,
    [companyApi.reducerPath]: companyApi.reducer,
    [shareholderApi.reducerPath]: shareholderApi.reducer,
    [documentApi.reducerPath]: documentApi.reducer,
    [packageApi.reducerPath]: packageApi.reducer,
    [stateApi.reducerPath]: stateApi.reducer,
    [statePriceApi.reducerPath]: statePriceApi.reducer,
    [mailBoxApi.reducerPath]: mailBoxApi.reducer,
    [rewardApi.reducerPath]: rewardApi.reducer,
    [supportServiceApi.reducerPath]: supportServiceApi.reducer,
    [supportApi.reducerPath]: supportApi.reducer,
    [bdShareholderApi.reducerPath]: bdShareholderApi.reducer,
    [renewalApi.reducerPath]: renewalApi.reducer,
    [businessTypeApi.reducerPath]: businessTypeApi.reducer,
    [countryApi.reducerPath]: countryApi.reducer,
    [entityEndingApi.reducerPath]: entityEndingApi.reducer,
    [sicApi.reducerPath]: sicApi.reducer,
    [businessActivityApi.reducerPath]: businessActivityApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
        companyApi.middleware,
        shareholderApi.middleware,
        documentApi.middleware,
        packageApi.middleware,
        stateApi.middleware,
        statePriceApi.middleware,
        mailBoxApi.middleware,
        rewardApi.middleware,
        supportServiceApi.middleware,
        supportApi.middleware,
        memberApi.middleware,
        bdShareholderApi.middleware,
        renewalApi.middleware,
        businessTypeApi.middleware,
        countryApi.middleware,
        entityEndingApi.middleware,
        sicApi.middleware,
        businessActivityApi.middleware,
    ),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
